import React, { Fragment } from 'react'
import { css } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { theme as deprecatedTheme } from '../../../styled'
import { AttackTypeTooltip } from './attack-type-tooltip'
import { FormattedMessage } from 'react-intl'
import { Tooltip } from '@contrast-security-inc/design-system-popovers'
import { ellipsis } from 'polished'

const attackValueCss = css`
  color: ${theme.color.neutral60};
  padding-top: 6px;
  ${ellipsis()}
`

export function AttackTypeCell({
  organizationID,
  rowData: { id, displayName, type, userInput }
}: {
  organizationID: string
  rowData: {
    id: string
    displayName: string
    type: string
    userInput?: {
      value: string
      truncatedValue?: boolean
    }
  }
}) {
  const value = userInput && userInput.value
  const truncatedValue = userInput && userInput.truncatedValue

  const TooltipChildren = React.forwardRef<HTMLDivElement>(
    ({ ...rest }, ref) => (
      <div className={attackValueCss} ref={ref} {...rest}>
        {type === 'VP' ? <FormattedMessage id="title_virtualPatch" /> : value}
      </div>
    )
  )

  return (
    <Fragment>
      <div
        className={css`
          font-family: ${deprecatedTheme.fontFamilies.secondary};
        `}
      >
        {displayName}
      </div>
      {value ? (
        <Tooltip
          body={
            <AttackTypeTooltip
              organizationID={organizationID}
              eventUuid={id}
              attackValue={value}
              truncatedValue={truncatedValue}
            />
          }
        >
          <TooltipChildren />
        </Tooltip>
      ) : (
        <TooltipChildren />
      )}
    </Fragment>
  )
}
